import React from 'react';
import * as _ from 'lodash';
import { messageUtility } from '../../utilities/messageUtility';

/**
 * idをもとにフルネームを取得する
 *
 * @param {*} selectedUsers
 * @param {*} userId
 * @returns
 */
const getFullname = (selectedUsers, userId) => {
  const res = selectedUsers.flatMap(item => {
    return item.id === userId ? item.fullname : [];
  });

  if (res.length > 0) {
    return res[0];
  }

  return '';
};

/**
 * 施工体系図の”検索して追加して”からの”協力会社ユーザーを検索して追加”での
 * Buildee未ログインの職長ユーザーの警告ダイアログ
 *
 * @param {*} props
 */
export class NotLoginForemanWarningDialog extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div
        className='dialog-md dialog--modal'
        onClick={event => {
          event.stopPropagation();
        }}
      >
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>
            {messageUtility.getMessage('I-001-008')}
          </span>
        </div>
        <div className='dialog-md__body'>
          <p>{messageUtility.getMessage('I-001-005')}</p>
        </div>
        <div className='dialog-md__footer-horizontal'>
          <button
            className='btn-fixedsize--sub'
            onClick={() => {
              this.props.onClose();
            }}
          >
            いいえ
          </button>
          <button
            className='btn-fixedsize--effective'
            onClick={() => {
              this.props.onExecute();
            }}
          >
            はい
          </button>
          <div className='dialog-md__body'>
            <p>{messageUtility.getMessage('I-001-006')}</p>
            {/* 対象のユーザ達(スクロール) */}
            <div className='dropdown-single-select__scroll'>
              {_.map(this.props.badUsers, (item, index) => {
                return (
                  <ul key={`bad_user_${index}`} className='single-select'>
                    <li className='single-select__item'>
                      <div className='single-select__label--center'>
                        {getFullname(this.props.assignedWorker, item.user_id)}
                      </div>
                    </li>
                  </ul>
                );
              })}
            </div>
          </div>
          <div className='dialog-md__body'>
            <p>{messageUtility.getMessage('I-001-007')}</p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/NotLoginForemanWarningDialog.jsx